var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.798 25.595a9.757 9.757 0 0 0 4.273-.978l-3.095-3.573a5.376 5.376 0 1 1 4.198-5.16h4.422v-.086C20.595 10.387 16.21 6 10.798 6S1 10.387 1 15.798c0 5.41 4.387 9.797 9.798 9.797zM21.202 6a9.758 9.758 0 0 0-4.273.979l3.095 3.571a5.376 5.376 0 1 1-4.198 5.16h-4.422v.088c0 5.41 4.386 9.797 9.797 9.797S31 21.21 31 15.798 26.613 6 21.202 6z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCet);
export default __webpack_public_path__ + "static/media/CET.5e0741851c1d89c9662a6a7c83fb332e.svg";
export { ForwardRef as ReactComponent };